import { createSlice } from "@reduxjs/toolkit";
import { getUsersByType } from "../actions/typeAction";

const typeSlice = createSlice({
  name: "users",
  initialState: {
    users: [],
    pagination: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUsersByType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUsersByType.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload.data || [];
        state.pagination = action.payload.pagination || {};
        state.error = null;
      })
      .addCase(getUsersByType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default typeSlice.reducer;
